module.exports = __webpack_public_path__ + "static/media/intake-follow-up-and-outcomes-questionnaires-01.4002ae85.png";